import { Component } from '@angular/core';

import { ActionSheet, ActionSheetController, Config, NavController, ToastController } from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { Http, Headers, RequestOptions } from '@angular/http';
import { CommonData } from '../../providers/common-data';
import { EmployeeavalabilitiesData } from './employeeavalability-data';
import { EmployeeavalabilityData } from './employeeavailability-data';
import { AlertController } from 'ionic-angular';
import moment from 'moment';


@Component({
  selector: 'employeeavailability-list',
  templateUrl: 'employeeavailability-list.html'
})
export class EmployeeavalabilityListPage {
  actionSheet: ActionSheet;
  eavailability;
  dBegin:any;
  dEnd:any;
  maxDate;
  minDate;
  command: string;

  constructor( public common: CommonData
              , public actionSheetCtrl: ActionSheetController
              , public navCtrl: NavController
              , public http: Http
              , public config: Config
              , public userData: UserData
              , public eavailabilityData: EmployeeavalabilityData
              , public alertCtrl: AlertController
              , public toastCtrl: ToastController
              ){
              eavailabilityData.updateRequired = true; 

  }

  ionViewWillEnter() {
    this.minDate = moment.utc().startOf('day').format('YYYY-MM-DD');
    this.maxDate = moment.utc().add(2, 'y').format('YYYY-MM-DD');    
    //console.log("ionwill enter employee avail");
    if(this.eavailabilityData.updateRequired){
      //console.log("ionwill enter employee avail2");
      Promise.all([    
        this.eavailabilityData.load(),
      ]).then(data => {
          this.eavailability = this.eavailabilityData.data;           
        });

    }
  }  
  executeAction(){
    if(this.command=="createEaEntries"){
      this.createEaEntries();

    }
    else if(this.command=="closePeriod"){
      this.closePeriod();
    }
    else{
      let toast = this.toastCtrl.create({
        message: "Aktion auswählen",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });
      toast.present();          
    }
  }

  closePeriod(){
    var data = JSON.stringify({
      dBegin: this.dBegin,
      dEnd: this.dEnd,
      token: this.userData.jwt
    });

    Promise.all([    
      this.eavailabilityData.closePeriod(data),            
    ]).then(data => {
      Promise.all([    
        this.eavailabilityData.load(),            
      ]).then(data => {
        //console.log(data);
        this.eavailability = this.eavailabilityData.data;           
      }); 
    });
  }

  createEaEntries(){
    var data = JSON.stringify({
      dBegin: this.dBegin,
      dEnd: this.dEnd,
      token: this.userData.jwt
    });

    Promise.all([    
      this.eavailabilityData.createEaEntries(data),            
    ]).then(data => {
      Promise.all([    
        this.eavailabilityData.load(),            
      ]).then(data => {
        //console.log(data);
        this.eavailability = this.eavailabilityData.data;           
      }); 
    });
  }  
  updateEa($event, ea){
   /* Sicherheitsabfrage auskommentiert das mühsam für planung
    if(ea.benutzer_id != this.userData.userid){
      
      let title = "Soll die Verfügbarkeit wirklich für "+ this.userData.employeeNameById(ea.benutzer_id) + " geändert werden?";
 
      let alert = this.alertCtrl.create();
      alert.setTitle(title);
      alert.addButton({
        text: 'Ja, ändern',
        handler: (data: any) => {
            
            Promise.all([
              this.eavailabilityData.update(ea),            
              ]).then(data => {
                 this.navCtrl.pop();
              });            
            //this.testCheckboxOpen = false;
        }
      });
      alert.addButton({
        text: 'Nein',
        handler: (data: any) => {
          Promise.all([    
            this.eavailabilityData.load(),            
          ]).then(data => {
            //console.log(data);
            this.eavailability = this.eavailabilityData.data;           
          });
        }
      });      

 
      alert.present();
      
    }
    else{
      */
      this.eavailabilityData.update(ea);
  //  }
  }

  
  doRefresh(refresh){
        Promise.all([
            this.eavailability.load(),            
          ]).then(data => {
            //console.log(data);
            this.eavailability = this.eavailabilityData.data;       
            if(refresh){
              refresh.complete();     
            }
          });    
    
  }  

}



// WEBPACK FOOTER //
// ./src/pages/employeeavailability/employeeavailability-list.ts